export class EncryptedForm {
  code: string;
  constructor(code: string) {
    this.code = code;
  }
}
